"use strict";
/* eslint-disable max-lines-per-function */
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
const React = __importStar(require("react"));
const line_1 = require("@nivo/line");
const constants_1 = require("./utils/constants");
const getPointColor = (pointColor) => {
    if (pointColor)
        return pointColor.pointColor;
    return { from: 'color', modifiers: [] };
};
const getCurveStyle = (curveStyle) => {
    if (curveStyle)
        return curveStyle;
    return constants_1.CurveStyle.LINEAR;
};
const getColoScheme = (colorScheme) => {
    if (colorScheme)
        return colorScheme;
    return constants_1.NivoColorScheme.NIVO;
};
exports.LineChart = (props) => {
    const { chartData, pointColor, pointSize, curveStyle, colorScheme } = props;
    return (React.createElement(line_1.ResponsiveLine, { data: chartData, curve: getCurveStyle(curveStyle), margin: { top: 50, right: 60, bottom: 80, left: 60 }, xScale: { type: 'point' }, yScale: { type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }, axisTop: null, axisRight: null, axisBottom: {
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Month',
            legendOffset: 40,
            legendPosition: 'middle',
        }, axisLeft: {
            orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Revenue',
            legendOffset: -50,
            legendPosition: 'middle',
        }, colors: { scheme: getColoScheme(colorScheme) }, pointSize: pointSize || 10, pointColor: getPointColor(pointColor), pointBorderWidth: 2, pointBorderColor: { from: 'serieColor' }, pointLabel: "y", pointLabelYOffset: -12, useMesh: true, legends: [
            {
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateX: 0,
                translateY: 75,
                itemsSpacing: 3,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1,
                        },
                    },
                ],
            },
        ] }));
};
//# sourceMappingURL=data:application/json;base64,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